import { useEffect, useState } from "react";
import { MainTemplates } from "../../components/template/MainTemplates";
import { MatchContents } from "../../components/organisms/MatchContentsList";
import { useQuery } from "@tanstack/react-query";
import { request } from "../../lib/api";
import {
  OrderType,
  SearchType,
  Transportation,
} from "../../interface/transportation";
import { useForm } from "react-hook-form";
import { STANDBY_TRANSPORTATIONS } from "../../common/query-keys";
import { ResponseType } from "../../types/response.types";
import { useNavigate } from "react-router";

const defaultSearch = [
  {
    data: "전체",
    point: "",
  },
];
const MatchListPage = () => {
  /** ============================= state 영역 ============================= */
  const navigate = useNavigate();
  const [search, setSearch] = useState<SearchType[]>([]);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const { register, handleSubmit, watch } = useForm();
  const [searchConfirm, setSearchConfirm] = useState<any>([]);

  // 정렬 상태
  const [orderType, setOrderType] = useState<boolean>(true);
  /** ============================= API 영역 ============================= */

  /** 배차 목록 리스트( 기사들이 올라와 있는 오더 리스트를 볼 수 있다 ) */

  const {
    data: orderData,
    isLoading: orderListLoading,
    refetch,
  } = useQuery({
    queryKey: [STANDBY_TRANSPORTATIONS, searchConfirm, orderType],
    queryFn: async () => {
      const result = await request<ResponseType<any>>({
        method: "POST", // POST로 변경
        url: `${STANDBY_TRANSPORTATIONS}`,
        data: { filters: searchConfirm, order: orderType }, // 서버로 필터 조건 전달
      });

      return result.data;
    },
  });

  /** ============================= 비즈니스 로직 영역 ============================= */
  /** 선택한 오더 단일 데이터를 props로 넘겨 오더 디테일 화면으로 이동  */
  const onDetailPageMoveHandler = (data: OrderType) => {
    navigate(`/matchListDetail`, {
      state: {
        item: data,
      },
    });
  };
  const onSearchHandler = () => {
    const data = watch();

    console.log("data", data);
    console.log("search", search);
    if (data.searchText === "") {
      console.log("검색!!");
      setSearchConfirm([...search]);
    } else {
      setSearchConfirm([...search, { point: "text", data: data.searchText }]);
    }
  };

  useEffect(() => {
    onSearchHandler();
  }, [search]);

  /** ============================= 컴포넌트 영역 ============================= */
  return (
    <MainTemplates pageTitle="운송매칭 리스트" gap="22px">
      <MatchContents
        orderData={orderData || []}
        showFilter={showFilter}
        search={search}
        setSearch={setSearch}
        setShowFilter={setShowFilter}
        register={register}
        onSearchHandler={onSearchHandler}
        handleSubmit={handleSubmit}
        onDetailPageMoveHandler={onDetailPageMoveHandler}
        orderType={orderType}
        setOrderType={setOrderType}
      />
    </MainTemplates>
  );
};
export default MatchListPage;
